import styled from "styled-components";
import Button from "./Button";
interface IButton {
  label: string;
  onClick: Function;
}
interface IConfirmPopup {
  header: string;
  content: string;
  confirm?: IButton;
  cancel?: IButton;
}
const ConfirmPopup = ({ header, content, confirm, cancel }: IConfirmPopup) => {
  return (
    <SContainer>
      <SContentContainer>
        <SHeader>{header}</SHeader>
        <SContent>
          {content.split(".").map((e, i) => {
            return (
              <div>
                {e}
                {i + 1 !== content.split(".").length ? "." : ""}
              </div>
            );
          })}
        </SContent>
        <SButtonContainer>
          {cancel ? (
            <Button
              onclick={cancel.onClick}
              addonCss={{
                border: "1px solid #E4E4E4",
                padding: "10px 35px",
                marginRight: "10px",
              }}
            >
              {cancel.label}
            </Button>
          ) : (
            ""
          )}
          {confirm ? (
            <Button
              onclick={confirm.onClick}
              addonCss={{
                color: "white",
                backgroundColor: "#3C7FEC",
                padding: "10px 35px",
                marginLeft: "10px",
              }}
            >
              {confirm.label}
            </Button>
          ) : (
            ""
          )}
        </SButtonContainer>
      </SContentContainer>
    </SContainer>
  );
};
export default ConfirmPopup;

const SContainer = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 30;
  animation: fadeIn 180ms ease-out;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const SContentContainer = styled.div`
  background-color: var(--color-surface);
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 380px;
  max-width: 90vw;
  overflow: hidden;
  animation: popIn 200ms cubic-bezier(0.4, 0, 0.2, 1);
  @keyframes popIn {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;
const SHeader = styled.div`
  border-bottom: 1px solid var(--color-border);
  padding: 16px 24px;
  font-weight: 600;
  width: 100%;
  font-size: 17px;
  color: var(--color-text);
`;
const SButtonContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  gap: 8px;
`;
const SContent = styled.div`
  min-height: 100px;
  width: 100%;
  padding: 24px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--color-text-muted);
  font-size: 14px;
  line-height: 1.55;
`;
